/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { APIgetStores } from "../../../api/settings.ts";
import { useSelector } from "react-redux";
const AddStoresModal = ({ onClose, onSelectStores, selected }) => {
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const [selectedStores, setSelectedStores] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]); // Added state for store options
  const [loading, setLoading] = useState(false); // Added state for store options
  const [searchTerm, setSearchTerm] = useState("");

  const handleSelectStore = (store) => {
    setSelectedStores((prevSelectedStores) =>
      prevSelectedStores?.includes(store)
        ? prevSelectedStores.filter((s) => s !== store)
        : [...prevSelectedStores, store]
    );
  };

  useEffect(() => {
    getStoreApi();
  }, []);

  const getStoreApi = async () => {
    try {
      setLoading(true);
      const res = await APIgetStores({});
      if (res?.response?.stores) {
        const storeData = res.response.stores.reverse();
        const storeOptions = storeData.map((store) => ({
          label: store.title,
          value: store._id,
          storeCode: store.storeNumber,
        }));
        setStoreOptions(storeOptions);
        setSelectedStores(selected);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleSave = () => {
    onSelectStores(selectedStores);
    onClose();
  };

  // Use storeOptions instead of stores to filter based on fetched data
  const filteredStores = storeOptions.filter(
    (store) => store.label.toLowerCase()?.includes(searchTerm.toLowerCase()) // filter by storeCode
  );

  // if (!isOpen) return null;
  const isExist = (store) => {
    const ex = selectedStores.some(
      (item) =>
        item.label === store.label &&
        item.value === store.value &&
        item.storeCode === store.storeCode
    );
    return ex;
  };
  return (
    <div className="modal fade show d-block add-stores-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> {t[l]?.["add_stores"] || "Add Stores"}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="search-set">
              <div className="search-input">
                <input
                  name="Search"
                  type="text"
                  placeholder={t?.[l]?.["search_store"] || "Search Store"}
                  className="form-control"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span
                  className="btn btn-searchset"
                  tabIndex="0"
                  style={{ paddingTop: "10px" }}
                >
                  <i className="feather-search" />
                </span>
              </div>
            </div>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        const allSelected = e.target.checked;
                        setSelectedStores(allSelected ? storeOptions : []);
                      }}
                      checked={selectedStores.length === storeOptions.length}
                    />
                  </th>
                  <th scope="col">{t[l]?.["name"] || "Name"}</th>
                  <th scope="col">{t[l]?.["store_code"] || "Store Code"}</th>
                </tr>
              </thead>
              <tbody className="stores-body">
                {loading && (
                  <div className="spinner-loader-wrapper">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
                {filteredStores.map((store, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={isExist(store)}
                        onChange={() => handleSelectStore(store)}
                      />
                    </td>
                    {/* <td>{JSON.stringify(selectedStores)} {JSON.stringify(store)} </td> */}
                    <td>{store.label}</td>
                    <td>{store.storeCode}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="modal-inner-footer-btn">
            <button
              type="button"
              className="btn btn-cancel me-2"
              onClick={onClose}
            >
               {t[l]?.["cancel"] || "Cancel"}
            </button>
            <button
              type="button"
              className="btn btn-submit"
              onClick={handleSave}
            >
              {t[l]?.["add"] || "Add"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AddStoresModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectStores: PropTypes.func.isRequired,
  selected: PropTypes.array,
};

export default AddStoresModal;
